import { Languages } from 'lucide-react';
import { cn } from '../lib/cn';
import { SUPPORTED_LANGUAGES, type SupportedLanguage } from '../lib/i18n';
import { useI18nTranslation } from '../lib/use-i18n-translation';

export interface LanguageSwitcherProps {
  className?: string;
}

/** Toggles the active language, which also flips `<html dir>` through the i18n init hook. */
export const LanguageSwitcher = ({ className }: LanguageSwitcherProps) => {
  const { t, language, changeLanguage } = useI18nTranslation();
  const current = language.split('-')[0] as SupportedLanguage;
  const next = SUPPORTED_LANGUAGES[(SUPPORTED_LANGUAGES.indexOf(current) + 1) % SUPPORTED_LANGUAGES.length] ?? 'en';

  return (
    <button
      type="button"
      onClick={() => changeLanguage(next)}
      title={t('language.label')}
      aria-label={`${t('language.label')}: ${t(`language.${next}`)}`}
      className={cn(
        'inline-flex h-8 items-center gap-1.5 rounded-md px-2 text-xs font-medium text-muted-foreground transition-colors hover:bg-muted hover:text-foreground',
        className,
      )}
    >
      <Languages className="size-3.5" />
      {t(`language.${next}`)}
    </button>
  );
};
